<template>
  <div class="plancontainer">
    <div class="content">
      <h1>{{title}}</h1>
      <h3>{{subhead}}</h3>
      <div v-html="conText" class="text">
      </div>
      <div class="clearfloat"></div>
    </div>
    <footBar></footBar>
  </div>
</template>
<script>
import footBar from '@/components/footbar'
import { planlist } from '@/services/api/index'
export default {
  name: 'productList',
  computed: {
    planId() {
      return this.$route.params.id
    }
  },
  watch: {},
  components: {
    footBar
  },
  data() {
    return {
      title: '',
      conText: '',
      subhead: ''
    }
  },
  mounted() {
    this.getplans();
  },
  methods: {
    getplans() {
      planlist().then(res => {

        for (var i = 0; i < res.data.total; i++) {
          if (res.data.CooperationProgrammes[i].id == this.planId) {
            this.conText = res.data.CooperationProgrammes[i].content
            this.title = res.data.CooperationProgrammes[i].title
            this.subhead = res.data.CooperationProgrammes[i].subhead
          }
        }
      })
    }
  }
}

</script>
<style rel="stylesheet/scss" lang="scss">
.plancontainer {
  padding: 20px 0 0 0;
  width: 100%;
  background-color: #F6F6F6;

  .content {
    padding: 55px;
    text-align: center;
    margin: 0 auto;
    width: 1200px;
    min-height: 900px;
    /* height:900px;         */
    background-color: #ffffff;
    margin-bottom: 20px;

    h1 {
      margin-bottom: 30px;
      font-size: 24px;
    }

    h3 {
      margin-bottom: 20px;
    }

    .text {
      text-align: left;
      line-height: 36px;
    }

    .clearfloat {
      clear: both;
      height: 0;
      font-size: 1px;
      line-height: 0px;
    }

    img {
      width: 75%;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/plandetail.vue